export default "__VITE_ASSET__CcW9bPmE__"